<template>
    <div class="alteration-references-ipf">
        <div v-if="!newForm">
            <div>
                <div class="filter-container">
                    <div class="left-content">
                        <b-dropdown class="filter-dropdown overflow-visible" variant="default" ref="drop">
                            <template #button-content>
                                <span class="lc"><i class="icon icon-filter"></i> {{ setText('filter') }} </span><span class="rc"><i
                                class="icon icon-keyboard"></i></span>
                            </template>
                            <div>
                                <div class="top-content">
                                    <span>{{ setText('filter_params') }}</span>
                                    <i class="icon icon-close" @click="$refs.drop.hide(true)"></i>
                                </div>
                                <div class="filter-block" v-if="['abp'].includes(accessLevels.position)">
                                    <b-form-group  :label="setText('subordinate_GA')">
                                        <div class="modal__toggle">
                                            <b-form-checkbox v-model="checkedGU" @input="checkGU" switch/>
                                        </div>
                                    </b-form-group>
                                </div>
                                <div class="filter-block-date-range">
                                    <label class="mr-3">{{ setText('period_from') }}</label>
                                    <date-picker
                                        :placeholder="setText('date_select')"
                                        v-model="dateFromForInput"
                                        format="DD/MM/YYYY"
                                        :append-to-body="false"
                                    />
                                    <label class="mx-3">{{ setText('period_to') }}</label>
                                    <date-picker
                                        :placeholder="setText('date_select')"
                                        v-model="dateToForInput"
                                        format="DD/MM/YYYY"
                                        :append-to-body="false"
                                    />
                                </div>
                                <div class="sp-block-alteration">
                                    <!---------------------АБП------------------------->
                                    <div class="filter-block m-0">
                                        <b-form-group :label="setText('abp')" >
                                            <multiselect
                                                v-model="currAbp"
                                                label="localText"
                                                :placeholder="setText('abp_select')"
                                                :options="abpBase"
                                                :searchable="true"
                                                :allow-empty="false"
                                                :show-labels="false"
                                                @input="loadFilters"
                                                ref="filterAbp"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!----------------Подведомственные-------------------->
                                    <div class="filter-block" v-if="currAbp && [261].includes(currAbp.abp) && ['abp'].includes(accessLevels.position)">
                                        <b-form-group :label="setText('subordinate')">
                                            <multiselect
                                                v-model="abp261gu"
                                                :options="departGU"
                                                label="localText"
                                                @input="sortData"
                                                :loading="loadingDepart"
                                                ref="refDepartGU"
                                                :disabled="loadingDepart"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!---------------------ГУ-------------------------->
                                    <div class="filter-block">
                                        <b-form-group :label="setText('ga')" v-if="['ipf'].includes(accessLevels.position) || (['abp'].includes(accessLevels.position) && checkedGU)">
                                            <multiselect
                                                :disabled="!guBase.length"
                                                v-model="currGu"
                                                label="localText"
                                                :placeholder="setText('ga_select')"
                                                :options="guBase"
                                                :searchable="true"
                                                :allow-empty="false"
                                                :show-labels="false"
                                                @input="guChange"
                                                ref="filterGu"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!---------------------Регион---------------------->
                                    <div class="filter-block">
                                        <b-form-group :label="setText('obl')">
                                            <multiselect
                                                v-model="currRegion"
                                                label="localText"
                                                :placeholder="setText('region_select')"
                                                :options="regionBase"
                                                :searchable="true"
                                                :allow-empty="false"
                                                :show-labels="false"
                                                :disabled="!(currAbp && currAbp.abp === 124 && !checkedGU)"
                                                ref="filterReg"
                                            />
                                        </b-form-group>
                                    </div>
                                    <div class="filter-block">
                                        <b-button variant="primary" @click="loadData(year, currRegion, currAbp, currGu)">{{ setText('apply') }}</b-button>
                                        <b-button variant="secondary" @click="clearParam">{{ setText('reset') }}</b-button>
                                    </div>
                                    <hr>
                                    <!------------------Вид заявки--------------------->
                                    <div class="filter-block">
                                        <b-form-group :label="setText('request_type')">
                                            <multiselect
                                                v-model="selectedAlteration"
                                                :placeholder="setText('rt_select')"
                                                :options="listAlteration"
                                                track-by="name"
                                                label="name"
                                                :searchable="true"
                                                :allow-empty="false"
                                                :show-labels="false"
                                                @input="typeChange"
                                                ref="refAlteration"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!------------------Статус------------------------->
                                    <div class="filter-block">
                                        <b-form-group :label="setText('status')">
                                            <multiselect
                                                v-model="selectedStatus"
                                                :placeholder="setText('status_select')"
                                                :options="listStatus"
                                                track-by="name"
                                                label="name"
                                                :searchable="true"
                                                :allow-empty="false"
                                                :show-labels="false"
                                                ref="refStatus"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </div>
                                    <!------------------Трансферт------------------------->
                                    <div class="filter-block">
                                        <b-form-group :label="setText('scorr_transf')">
                                            <div class="modal__toggle">
                                                <b-form-checkbox v-model="transfert" switch/>
                                            </div>
                                        </b-form-group>
                                    </div>
                                    <div class="filter-block">
                                        <b-button variant="primary" @click="filterApply">{{ setText('apply') }}</b-button>
                                        <b-button variant="secondary" @click="clearFilter">{{ setText('reset') }}</b-button>
                                    </div>
                                    <hr>
                                </div>
                            </div>
                        </b-dropdown>
                    </div>
                    <div class="filter-actions">
                        <b-button v-if="accessLevels && ['abp'].includes(accessLevels.position)" :disabled="!accessLevels.editAccess || cDis"  style="position: absolute; z-index: 1; right: 130px;" :visible="accessLevels && ['abp'].includes(accessLevels.position)" variant="primary" @click="modalConsolOpen(null, false)">
                            <span>{{ setText('consolidate') }}</span>
                        </b-button>
                        <b-button :disabled="!accessLevels.editAccess || disButton" variant="primary" @click="modalConsolOpen(null, true)">
                            <span>{{ setText('create') }}</span>
                        </b-button>
                    </div>
                </div>
            </div>
            <!--  хлебные крошки   -->
            <div class="filter-breadcrumb">
                <span class="item-breadcrumb" v-if="year" @click="openFilterByRef('filterYear')"> {{ year }} </span>
                <span class="item-breadcrumb" v-if="currAbp" @click="openFilterByRef('filterAbp')"> {{currAbp.abp}}-{{ setText('abp') }} </span>
                <span class="item-breadcrumb" v-if="(currGu && accessLevels.position === 'ipf')" @click="openFilterByRef('filterGu')"> {{currGu.code}}-{{ setText('ga') }} </span>
                <span class="item-breadcrumb" v-if="currRegion" @click="openFilterByRef('filterReg')"> {{ currRegion.localText}} </span>
                <span class="item-breadcrumb" v-if="selectedAlteration" @click="openFilterByRef('refAlteration')"> {{ setText('request_type') }} - {{selectedAlteration.name}} </span>
                <span class="item-breadcrumb" v-if="selectedStatus" @click="openFilterByRef('refStatus')"> {{ setText('status') }} - {{selectedStatus.name}} </span>
            </div>
            <CRequestsTable
                :guBase="guBase"
                :currAbp="currAbp"
                @editCurrentGu="$set($data, 'currGu', $event)"
                :requestsBase="requestsBase"
                @onChange="onChange"
                @onOpen="onOpen"
                @onDelete="onDelete"
                @chgData="chgData"
                @onChecked="onChecked"
                :levelsCheck="true"
                :requestTypeOptions="requestTypeOptions"
                :accessLevels="accessLevels"
                :activeTab="activeTab"
                :statusType="listStatus"
                :inc-tab="true"
                :edit-access-status-list="[1, 3, 69]"
                :tabIndex="tabIndex"
                :verifyReport="verifyReport"
                :tabCode="tabCode"
                @reload-journal="$emit('reload-journal')"
                :isLoadToJournalEnabled="isLoadToJournalEnabled"
                :isTransfert="transfert"
                :showId="false"
            />
            <!-- Отображение количества заявок -->
            <div class="requests-count" v-if="requestsBase && requestsBase.length > 0">
                {{ setText('requests_count') }}:  {{ requestsBase.length }}
            </div>
            <div class="requests-count" v-else>
                {{ setText('no_requests_found') }}
            </div>
            <b-modal
                size="lg"
                id="modal-create"
                v-model="modalForm"
                centered
                hide-header
                hide-footer
                title="modalTitle"
            >
                <div class="add_modal">
                    <div class="add_modal__title" v-if="requestStatus">{{ setText('edit') }}</div>
                    <div class="add_modal__title" v-if="!requestStatus">{{ setText('create') }}</div>

                    <div class="add_modal__body">
                        <div class="add_modal__item">
                            <div class="add_modal__item__title">№</div>
                            <div class="date-picker-container">
                                <b-form-input
                                    type="number"
                                    :min="1"
                                    class="form-input"
                                    v-model="alterationType.number"
                                    :formatter="formatter"
                                    @keypress="keyPress($event, '^\\d*\\d{0,9}$')"
                                    @change="saveFalse = false"
                                />
                                {{ setText('date') }}
                                <date-picker
                                    :placeholder="setText('date_select')"
                                    v-model="curDate"
                                    format = "DD/MM/YYYY"
                                    type="date"
                                    style="max-width: 500px"
                                    :disabled-date="createDateDisabled"
                                    @input="dateChange"
                                />
                            </div>
                        </div>
                        <div class="add_modal__item">
                            <div class="add_modal__item__title">{{ setText('request_type') }}</div>
                            <multiselect
                                v-model="selectedReqType"
                                label="name"
                                :placeholder="setText('rt_select')"
                                :options="requestTypeList"
                                style="width: 480px"
                                :searchable="true"
                                :allow-empty="false"
                                :show-labels="false"
                                @input="reqTypeClick"
                                ref="filterAbp"
                            />
                        </div>
                        <div class="add_modal__item">
                            <div class="add_modal__item__title black">{{ setText('onBased') }}</div>
                            <b-form-input
                                id="textarea"
                                :placeholder="setText('description_add')"
                                type="text"
                                v-model="alterationType.description"
                                class="input"
                                style="width: 480px"
                            ></b-form-input>

                        </div>
                        <div class="add_modal__item">
                            <label class="input-file-label"
                            >{{ setText('document_attach') }}</label
                            >
                            <b-form-file v-model="file"
                                         id="fileInput"
                                         accept=".xls, .xlsx, .pdf, .doc, .docx"
                                         placeholder=""
                                         :browse-text = "setText('review')"
                                         @change="syncFile"
                                         size="sm"
                                         style="width: 760px" >
                            </b-form-file>
                        </div>
                        <div class="col-md-12" v-if="editRequest">
                            <table class="table table-striped"
                                   style="font-weight: 600;
                                          font-size: 14px;
                                          color: #6087a0;">
                                <tr v-for="(file, index) in editedAlterationFiles" :key="'index'+index">
                                    <td>{{file.name}}</td>
                                    <td><button class="button button-close"
                                                @click="deletedAlterationFiles.push(file); editedAlterationFiles.splice(index, 1);">x</button></td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-md-12" v-if="!editRequest">
                            <table class="table table-striped"
                                   style="font-weight: 600;
                                          font-size: 14px;
                                          color: #6087a0;">
                                <tr v-for="(file, index) in createdAlterationFiles" :key="'index'+index">
                                    <td>{{file.name}}</td>
                                    <td><button class="button button-close"
                                                @click="deletedAlterationFiles.push(file); createdAlterationFiles.splice(index, 1);">x</button></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <div v-if="saveTrue">
                        <p style="color: red;  font-size: 14px;">{{typeName}}</p>
                    </div>
                    <div v-if="saveFalse">
                        <h6 style="color: red; font-size: 14px;">{{ numberName }}</h6>
                    </div>
                    <div class="add_modal__footer">
                        <b-button variant="primary"  @click="saveRequest">{{ setText('save') }}</b-button>
                        <b-button variant="secondary"  @click="onClose">{{ setText('cancel') }}</b-button>
                    </div>
                </div>
            </b-modal>
        </div>
        <div v-if="newForm">
            <new-alteration-form :currentAlteration="currentAlteration"
                                 :currAbp="currAbp"
                                 :currGu="currGu"
                                 :currRegion="currRegion"
                                 :guBase="guBase"
                                 :listAlteration="listAlteration"
                                 :accessLevel="accessLevels"
                                 :moduleCode="moduleCode"
                                 :mode="mode"
                                 :newRequest="newRequest"
                                 :tableType="0"
                                 @onBack="onBack"
                                 :tab-index="tabIndex"
                                 :tabCode="tabCode"
                                 @reload-journal="$emit('reload-journal')"
                                 :isLoadToJournalEnabled="isLoadToJournalEnabled"
                                 :activeTab="activeTab"
                                 :isTransfert="transfert">
            </new-alteration-form>
        </div>
        <loading
            :active="loading"
            is-full-screen
            spinner="bar-fade-scale"
            color="#6495ED"
        />
    </div>
</template>

<script>
import CRequestsTable from "./c-requests-table.vue";
import VueElementLoading from "vue-element-loading";
import newAlterationForm from "@/modules/budget/alteration/form/tabs/components/CreateForm/newAlterationForm";
import DatePicker from "vue2-datepicker";
import store from "@/services/store";
import moment from "moment";
import AlterationI18nMixin from "@/modules/budget/alteration/mixins/alteration-i18n-mixin";
import _ from "lodash";
import {clampToPeriod, isOutOfPeriod} from "@/modules/budget/alteration/form/tabs/filter-period";

export default {
    name: "AlterationReferences",
    components: { CRequestsTable, DatePicker, 'loading': VueElementLoading, newAlterationForm },
    mixins: [ AlterationI18nMixin ],
    data() {
        return {
            year: `${new Date().getFullYear()}`,
            selectedAlteration: {},
            typeAlteration: [],
            listAlteration: [
                {code: 'all', name_ru: 'Все', name_kk: 'Барлығы', name_en: 'All'}
            ],
            requestTypeList: [],
            selectedStatus: {},
            listStatus: [],
            loading: false,
            modalForm: false,
            showBr: false,
            selectedReqType: null,
            currAbp: null,
            abpBase: [],
            currGu: null,
            guBase: [],
            guFullBase: [],
            guItems: [],
            guArr: [],
            abp261gu: null,
            departGU: [],
            arrGU: {},
            currRegion: null,
            requestsBase: null,
            requestsData: null,
            userAbp: null,
            files: [],
            currAltStatusEdit: false,
            currentAlteration: {
                id: null,
                number: null,
                gu: null,
                date: new Date(),
                requestType: null,
                budgetVersion: null,
                planType: null,
                requestLevel: null,
                user_id: null,
                create_date: null,
                update_date: null,
                delete_date: null,
                fileList: []
            },
            currentAbpAlteration: {
                id: null,
                number: null,
                gu: null,
                date: new Date(),
                requestType: null,
                budgetVersion: null,
                planType: null,
                requestLevel: null,
                user_id: null,
                create_date: null,
                update_date: null,
                delete_date: null,
                fileList: []
            },
            createdAlterationFiles: [],
            editedAlterationFiles: [],
            deletedAlterationFiles: [],
            newForm: false,
            file: null,
            saveTrue: false,
            saveFalse: false,
            variantBase: [],
            currentVariant: null,
            alterationType: {},
            cDis: true,
            errorVariant: false,
            newRequest: false,
            editRequest: false,
            requestStatus: false,
            checkedGU: false,
            transfert: false,
            curComp: [],
            regionBase: [],
            disButton: true,
            checkCount: 0,
            userList: [],
            dateFromForInput: null,
            dateToForInput: null,
            dateFrom: null,
            dateTo: null,
            selectedAlt: {},
            curDate: new Date(`${new Date()}`),
            guList: '',
            loadingDepart: false,
            isUpdatingFilters: false,
            lastParams: null
        }
    },
    computed: {
        alteration() {
            let res = {};
            if (this.accessLevels.position === 'ipf') {
                res = this.alterationType;
            }
            if (this.accessLevels.position === 'abp') {
                res = this.alterationType;
            }
            return res;
        },
        mode() {
            return 'exc';
        },
        numberName() {
            return this.setText('num_already_exists') + this.alterationType.number + this.setText('num_already_exists2');
        },
        typeName() {
            let name = ''
            if (this.alterationType.description === null) {
                name = name + this.setText('base');
            }
            if (this.alterationType.requestType === null) {
                if (name.length > 0) { name = name + ' , '}
                name = name + this.setText('request_type');
            }
            if (this.alterationType.number === '' || this.alterationType.number === null) {
                if (name.length > 0) { name = name + ' , '}
                name = name + '"№"';
            }
            return this.setText('required_fields') + name;
        },
        locale() {
            return this.$i18n.locale;
        },
        verifyReport(){
            return  {
                dateFrom: moment(this.dateFromForInput).format('YYYY-MM-DD'),
                dateTo: moment(this.dateToForInput).format('YYYY-MM-DD'),
                selectedAlteration: this.selectedAlteration?.code,
                selectedStatus: this.selectedStatus?.code,
                region: this.currRegion?.code,
                // фильтр «Подведомственные»: код подведомственной, 0 — «Все»
                gu261: this.abp261gu?.code ?? 0,
                // дата, на которую строился список подведомственных, — чтобы состав отчёта совпадал с фильтром
                guDate: moment(this.curDate).format('YYYY-MM-DD')
            };
        },
        guEdit(){
            let guEd = 0;
            if (this.accessLevels && this.accessLevels.operations) {
                this.accessLevels.operations.forEach((op, ind) => {
                    if (op.toLowerCase().lastIndexOf('gu_edit') !== -1) {
                        guEd += 1;
                    }
                });
            }
            return guEd > 0
        }
    },
    async mounted() {
        this.loading = true;
        this.dateFromForInput = moment().startOf('month').toDate();
        this.dateToForInput = moment().endOf('month').toDate();
        this.loading = false;
        if (['ipf'].includes(this.accessLevels.position)) {
            this.disButton = !this.guEdit;
        }
    },
    async created() {
        await this.loadGUList();
        await this.loadAbpList();
        await this.loadStatusList();
        this.typeListLoad();
        this.selectedStatus = this.listStatus[0];
        this.selectedAlteration = this.listAlteration[0];
        this.currRegion = this.regionBase[0];
        this.$watch('reLoadChild', async () => {
            if (this.reLoadChild) {
                await this.loadData(this.year, this.currRegion, this.currAbp, this.currGu);
                this.cDis = true;
                this.$emit('unReLoadChild', false);
            }});
    },
    watch: {
        accessLevels: function(){
            if (['ipf'].includes(this.accessLevels.position)) {
                this.disButton = !this.guEdit;
            }
        },
        currRegion: function(){
            if (!this.isUpdatingFilters) {
                this.debouncedLoadData();
            }
        },
        currGu: function(){
            if (!this.isUpdatingFilters) {
                this.debouncedLoadData();
            }
        }
    },
    props: ["requestTypeOptions", "accessLevels", "userId", "moduleCode", "yearList", "activeTab", "tabIndex", "tabCode", "reLoadChild", "isLoadToJournalEnabled"],
    methods: {
        debouncedLoadData: _.debounce(function() {
            this.loadData(this.year, this.currRegion, this.currAbp, this.currGu);
        }, 100),  // 100 мс — достаточно для объединения вызовов; можно скорректировать
        formatter(value) {
            return value.replace("-", "")
        },
        onBack(val) {
            this.newForm = val;
            this.loadData(this.year, this.currRegion, this.currAbp, this.currGu);
            if (this.selectedAlteration !== null && this.selectedAlteration.code !== 'all') {
                this.requestsBase = this.requestsBase.filter((item) => item.requestType === this.selectedAlteration.code);
            }
            if (this.selectedStatus !== null && this.selectedStatus.code !== 0) {
                this.requestsBase = this.requestsBase.filter((item) => item.status.status === this.selectedStatus.code);
            }
        },
        chgData(data) {
            try {
                this.requestsBase = data;
            } catch (error) {
                this.makeToast('danger', this.setText('warning'), this.setText('errors.param') + error.toString());
            }
        }, // обновление параметров
        onChange(val) {
            this.currentAlteration = val;
            this.modalConsolOpen(this.currentAlteration, true);
        },
        onChecked(val) {
            this.cDis = !(val !== 0);
        },
        onOpen(val) {
            this.currentAlteration = val;
            this.newForm = true;
        },
        onDelete(val) {
            if (val) {
                this.deleteRequest(val);
            }
        },
        onClose() {
            this.modalForm = false;
            this.newRequest = false;
            if (this.alterationType.hasOwnProperty('oldDate')) {
                this.$set(this.alterationType, 'date', this.alterationType.oldDate);
            }
        },
        async modalConsolOpen(item, created) {
            if (created && item === null && (!this.currGu || this.currGu.code === 0 || this.currGu.code === '0')) {
                this.makeToast('warning', this.setText('warning'), this.$t('modules.budget_sum_calc.sum_calc_edit.not_selected_gu'));
                return;
            }
            if (item === null) {
                let prm = ""
                if (!created) {
                    prm = "/api/budget-execution-alteration-abp-request/create-request-template?abp=" + this.currAbp.abp;
                    // АБП 124: сквозная нумерация ведётся отдельно по каждому коду региона
                    if (this.currAbp && (this.currAbp.abp === 124 || this.currAbp.abp === '124') && this.currRegion?.code) {
                        prm += `&region=${this.currRegion.code}`;
                    }
                    // Проверка на АБП 123
                    if (this.currAbp && (this.currAbp.abp === 123 || this.currAbp.abp === '123')) {
                        let consolGu = null;

                        // Получаем ГУ из выбранной для консолидации заявки
                        if (this.requestsBase) {
                            const checkedItem = this.requestsBase.find(r => r.check);
                            if (checkedItem && checkedItem.gu) {
                                consolGu = checkedItem.gu;
                            }
                        }

                        // Если ГУ найдено, вызываем сервис проверки фактического региона
                        if (consolGu) {
                            try {
                                const resFact = await fetch(`/api/budget-execution-alteration-abp-request/gu-fact-region?abp=${this.currAbp.abp}&gu=${consolGu}`);
                                if (resFact.ok) {
                                    const factRegion = await resFact.text();
                                    // Если регион вернулся, добавляем ГУ к следующему сервису
                                    if (factRegion && factRegion.trim() !== '' && factRegion !== 'null') {
                                        prm += `&gu=${consolGu}`;
                                    }
                                }
                            } catch (e) {
                                console.error('Error fetching gu-fact-region:', e);
                            }
                        }
                    }
                    this.newRequest = false;
                }
                else {
                    prm = "/api/budget-execution-alteration-request/create-request-template?gu=" + this.currGu.code;
                    this.newRequest = true;
                }
                this.editRequest = false;
                const res = await fetch(prm);
                const data = await res.json();
                this.currAltStatusEdit = false;
                this.alterationType = data;
                this.createdAlterationFiles = this.alterationType.fileList;
                if (this.createdAlterationFiles !== null && this.createdAlterationFiles !== undefined) {
                    for (let i = 0; i < this.createdAlterationFiles.length; i++) {
                        this.createdAlterationFiles[i].old = true;
                    }
                    this.alterationType.fileList = null;
                }
                this.requestStatus = false;
            } else {
                this.currAltStatusEdit = true;
                this.alterationType = {
                    id: item.id,
                    number: item.number,
                    gu: item.gu,
                    abp: item.abp,
                    date: item.date,
                    requestType: item.requestType,
                    description: item.description,
                    user_id: item.user_id,
                    level: item.level,
                    fileList: item.fileList
                };
                this.editedAlterationFiles = [];
                for (const file of this.alterationType.fileList) {
                    this.editedAlterationFiles.push({...file});
                }
                if (this.editedAlterationFiles.length !== 0) {
                    for (let i = 0; i < this.editedAlterationFiles.length; i++) {
                        this.editedAlterationFiles[i].old = true;
                    }
                    this.alterationType.fileList = null;
                }
                this.newRequest = false;
                this.editRequest = true;
                this.requestStatus = true;
            }
            this.saveFalse = false;
            this.alterationType.date = new Date(this.alterationType.date);
            // «Создать» (заявка ГУ) и «Сконсолидировать» (справка/заявка АБП): дата — в пределах периода из фильтра этой вкладки
            if (!this.currAltStatusEdit) {
                this.alterationType.date = clampToPeriod(this.alterationType.date, this.dateFromForInput, this.dateToForInput);
            }
            this.curDate = new Date(this.alterationType.date);
            this.dateFrom = new Date(`${this.curDate.getFullYear()}-${this.curDate.getMonth() + 1}` + '-01');
            this.dateTo = new Date(`${this.curDate.getFullYear()}-${this.curDate.getMonth() + 1}-${new Date(this.curDate.getFullYear(), this.curDate.getMonth() + 1, 0).getDate()}`)
            if (this.currAltStatusEdit) {
                this.alterationType.gu = this.currGu.code;
            }
            if (this.alterationType.abp === null) {
                this.alterationType.abp = this.currAbp.abp;
            }
            if (this.alterationType.region === null) {
                this.alterationType.region = this.currRegion.code;
            }
            if (this.alterationType.user_id === null) {
                this.alterationType.user_id = this.userId;
            }
            this.selectedReqType = null;
            for (const item of this.requestTypeOptions) {
                if (item.code === this.alterationType.requestType) {
                    this.selectedReqType = item;
                }
            }
            this.$bvModal.show('modal-create');
        },
        reqTypeClick() {
            this.alterationType.requestType = this.selectedReqType.code;
        },
        async loadStatusList() {
            let response = [];
            try {
                response = await fetch('/api-py/get-full-status-list/' + this.mode);
                this.listStatus = await response.json();
                this.nameLocale(this.listStatus);
                this.selectedStatus = this.listStatus[0];
            } catch (error) {
                response = [];
                this.makeToast("danger", this.setText('errors.status'), error.toString());
            }
        },
        async loadAbpList() {
            let response = [];
            try {
                response = await fetch('/api-py/user-abp-list/' + this.userId);
                const newBase = await response.json();
                this.abpBase = this.setIdArr(newBase, "abp");

                this.nameLocale(this.abpBase, 'abp');
                this.abpBase
                    .sort((a, b) => (a.abp - b.abp > 0 ? 1 : -1));
                this.currAbp = this.abpBase[0];
                await this.loadRegions();
                await this.loadCompany();
            } catch (error) {
                response = [];
                this.makeToast("danger", this.setText('errors.abp'), error.toString());
            }
        },
        loadGUList: async function () {
            let response = [];
            try {
                response = await fetch('/api-py/user-gu-list/' + this.userId);
                this.guFullBase = await response.json();
                this.nameLocale(this.guFullBase, 'gu');
                this.guFullBase
                    .sort((a, b) => (a.gu - b.gu > 0 ? 1 : -1));
            } catch (error) {
                this.makeToast("danger", this.setText('errors.gu'), error.toString());
            }
        },
        setIdArr(arr, codeName) {
            const result = [];
            for (const el of arr) {
                if (
                    result.length > 0 &&
                    el[codeName] === result[result.length - 1][codeName]
                ) {
                    result[result.length - 1].idArr.push(el.id);
                } else {
                    result.push(Object.assign({ idArr: [el.id] }, el));
                }
            }
            return result;
        },
        async loadCompany() {
            let result = [];
            this.guItems = [];
            this.guList = '';
            this.currGu = null;

            if (this.currAbp !== null) {
                this.guBase = [];
                // Проверяем наличие прав доступа ABP напрямую через accessLevels
                const hasAbpAccess = this.accessLevels.operations && this.accessLevels.operations.some(op => op.toLowerCase().includes('abp'));
                if (hasAbpAccess && [261].includes(this.currAbp.abp)) {
                    // Для 261 АБП загружаем иерархию через loadDepartGU
                    await this.loadDepartGU();
                } else {
                    try {
                        const response = await fetch(`/api/budget-execution-base/user/gu?abp=${this.currAbp.abp}`);
                        result = await response.json();
                        try {
                            this.guBase = result;
                            if (Array.isArray(this.guBase) && this.guBase.length > 0) {
                                this.nameLocale(this.guBase, 'code');
                                this.guBase.sort((a, b) => (a.code - b.code > 0 ? 1 : -1))
                                    .map((item) => {
                                        this.guItems.push(item.code)

                                        return item;
                                    });
                                this.guList = this.guBase
                                    .map(item => `${item.id_region}`)
                                    .join(', ');
                                this.currGu = this.guBase[0];
                                if (this.currGu) {
                                    await this.getRegionByCodeGu();
                                }
                            }
                        } catch (error) {
                            this.makeToast('danger', this.setText('errors'), error.toString());
                        }
                    } catch (error) {
                        result = [];
                        this.makeToast('danger', this.setText('errors.gu'), error.toString());
                    }
                    this.abp261gu = null;
                }
            }
        },
        async guChange() {
            // if (this.currGu && this.currGu.code) {
            //     this.currGu = this.setNameLang(this.findElByCode('code', this.currGu.code, this.guBase), '');
            // } else {
            //     this.currGu = this.setNameLang(this.guBase[0], '');
            // }
            await this.getRegionByCodeGu();
        },
        setNameLang(obj, codeName) {
            if (obj === null) { return null; }
            let txt = obj['name_' + this.$i18n.locale];
            if (txt === undefined) { txt = obj.name_ru; }
            if (codeName !== undefined && codeName !== null && obj[codeName] !== undefined) {
                if (codeName === 'code') { txt = txt }
                else { txt = obj[codeName] + ' - ' + txt }
            }
            const el = Object.assign({}, obj);
            el.name = txt;
            el.localText = txt;
            return el;
        },
        findElByCode(codeName, code, arr) {
            if (code === null) { return null; }
            for (const el of arr) {
                if (el[codeName] === code) {
                    return el;
                }
            }
            return null;
        },
        async getRegionByCodeGu() {
            this.regionBase = [];
            let result = [];
            if ([124].includes(this.currAbp.abp) && !this.checkedGU) {
                const params = this.guList;
                try {
                    result = await fetch('/api-py/get-region-by-code-gu-arr/' + params,
                        {
                            method: "POST",
                            headers: {
                                'Content-Type': 'application/json;charset=utf-8'
                            }
                        })
                        .then(response => response.json())
                        .then(json => this.regionBase = json);
                    this.nameLocale(this.regionBase);
                    if (this.regionBase !== undefined) {
                        this.currRegion = this.regionBase[0];
                    }
                    if (['abp'].includes(this.accessLevels.position)) {
                        this.currGu = null;
                    }
                } catch (error) {
                    result = [];
                    this.makeToast('danger', this.setText('errors.region'), error.toString());
                }
            } else {
                if (this.currGu && this.currGu.id_region) {
                    try {
                        result = await fetch('/api-py/get-region-by-code-gu',
                            {
                                method: "POST",
                                headers: {
                                    'Content-Type': 'application/json;charset=utf-8'
                                },
                                body: JSON.stringify(this.currGu)
                            })
                            .then(response => response.json())
                            .then(json => this.regionBase = json);

                        this.nameLocale(this.regionBase);
                        if (this.regionBase !== undefined) {
                            this.currRegion = this.regionBase[0];
                        }
                    } catch (error) {
                        result = [];
                        this.makeToast('danger', this.setText('errors.region'), error.toString());
                    }
                }
            }
        },
        isGuFilter(arr) {
            if (arr && arr.length > 0) {
                arr.forEach((item) => {
                    if (item.gu.substring(0, 3) === this.currAbp.abp.toString()) {
                        this.guBase.push(item);
                    }
                });
            }
            return this.currGu;
        },
        async loadDepartGU() {
            if (this.departGU && this.departGU.length > 0) {
                if (this.abp261gu === null) {
                    this.abp261gu = this.departGU[0];
                    await this.sortData();
                }
                return;
            }
            const that = this;
            this.loadingDepart = true;
            try {
                const paramsObj = {
                    date: moment(that.curDate).format('YYYY-MM-DD'),
                    userId: that.userId
                };
                const response = await fetch('/api-py/get-gu-abp261/' + encodeURI(JSON.stringify(paramsObj)));
                const data = await response.json();
                if (data && data.length > 0) {
                    // Собираем все уникальные ГУ из arrGu всех подведомственных
                    const allGuMap = new Map();
                    data.forEach(dep => {
                        dep.arrGu.forEach(gu => {
                            if (!allGuMap.has(gu.code)) {
                                allGuMap.set(gu.code, gu);
                            }
                        });
                    });

                    if (data.length > 1) {
                        const allArrGu = Array.from(allGuMap.values());
                        // Добавляем объект "Все" с объединенными arrGu
                        data.push({
                            "name_ru": "Все",
                            "name_kk": "Барлығы",
                            "name_en": "All",
                            "code": 0,
                            "arrGu": allArrGu
                        });
                    }

                    data.sort((a, b) => (a.code - b.code > 0 ? 1 : -1));
                    // Сохраняем текущий выбор подведомственного ГУ, если он еще доступен в новом списке
                    const prevCode = this.abp261gu ? this.abp261gu.code : null;
                    this.departGU = data;
                    this.nameLocale(this.departGU);
                    if (prevCode !== null) {
                        const found = this.departGU.find(item => item.code === prevCode);
                        this.abp261gu = found || this.departGU[0];
                    } else {
                        this.abp261gu = this.departGU[0];
                    }
                    // Добавленный вызов для инициализации guBase и выбора "ВСЕ"
                    await this.sortData();
                } else {
                    this.departGU = [];
                    this.abp261gu = null;
                    this.guBase = [];
                }
            } catch (error) {
                this.departGU = [];  // Добавлено: инициализация пустым массивом для избежания undefined в nameLocale
                this.abp261gu = null;
                this.guBase = [];
                this.makeToast('danger', this.setText('errors.ga'), error.toString());
            } finally {
                this.loadingDepart = false; // <-- выключаем лоадер в любом случае (успех или ошибка)
            }
        },
        async sortData() {
            const abp = this.abp261gu;
            if (!abp) return;
            // Если выбран пункт "ВСЕ", задаем id_region из первых 2 символов текущей области + '0101'
            if (abp.code === 0 && this.currRegion && this.currRegion.code) {
                abp.id_region = String(this.currRegion.code).substring(0, 2) + "0101";
            }
            // 1. Упрощаем логику формирования arrGU
            this.arrGU = (abp.code !== 0 && abp.arrGu) ? abp.arrGu.join(',') : {}; // Оставляем {}, если так ожидает остальной код

            const guList = abp.arrGu;
            if (guList && Array.isArray(guList) && guList.length > 0) {  // Добавлена проверка Array.isArray для безопасности
                // 2. Сортировка и форматирование локального текста
                // Используем spread оператор [...], чтобы не мутировать исходный abp.arrGu
                const locale = this.$i18n.locale;
                this.guItems = [];
                this.guBase = [...guList]
                    .sort((a, b) => a.code - b.code)
                    .map(item => {
                        const name = item[`name_${locale}`] || item.name_ru;
                        this.guItems.push(item.code)
                        return {
                            ...item,
                            localText: item.code === 0 ? `${name}` : `${item.code} - ${name}`
                        };
                    });

                // 3. Установка текущего ГУ
                this.currGu = this.guBase[0];
                // Переносим id_region из свойств выбранного подведомственного ГУ в текущее ГУ
                if (this.currGu) {
                    this.currGu.id_region = abp.id_region;
                }

                // Обновляем регион по новому id_region
                await this.getRegionByCodeGu();

            } else {
                this.guBase = [];
                this.currGu = null;
            }
        },
        async loadRegions() {
            try {
                this.regionBase = [];
                const response = await fetch('/api-py/get-user-regions-by-uuid/' + store.state.user.sub);
                if (response.status === 200) {
                    this.regionBase = await response.json();
                    this.nameLocale(this.regionBase);
                    this.currRegion = this.regionBase[0];
                }
            } catch (error) {
                this.makeToast('danger', this.setText('region'), error.toString());
            }
        }, // справочник регионов
        async loadData(year, region, abp, gu) {
            // const paramsKey = `${year}_${region?.code}_${abp?.abp}_${gu?.code}`;
            // if (paramsKey === this.lastParams) return; // Избежать повторной загрузки с теми же параметрами
            // this.lastParams = paramsKey;
            let response = [];
            if ((year || region || abp || gu)) {
                try {
                    this.requestsBase = [];
                    const dateFrom = this.dateFromForInput.toLocaleDateString().split('.').reverse().join('-');
                    const dateTo = this.dateToForInput.toLocaleDateString().split('.').reverse().join('-');
                    if ((this.accessLevels.position === 'ipf') || (gu !== null && gu.code !== 0 && gu.code !== '0' && (['abp'].includes(this.accessLevels.position) && this.checkedGU))) {
                        response = await fetch(
                            `/api/budget-execution-alteration-request/list?region=${region?.code}&abp=${abp.abp}&dateBegin=${dateFrom}&dateEnd=${dateTo}&gu=${gu?.code}`
                        );
                    } else {
                        response = await fetch(
                            `/api/budget-execution-alteration-request/list?abp=${abp.abp}&dateBegin=${dateFrom}&dateEnd=${dateTo}`
                        );
                    }
                    response = await response.json();
                    this.getData(response);
                } catch (error) {
                    response = [];
                    this.loading = false;
                    this.makeToast(
                        "danger",
                        this.setText('errors.download'),
                        error.toString()
                    );
                }
            }
        },
        // Обновленный метод для базовой фильтрации
        baseFilter(data) {
            if (this.accessLevels.position !== "abp") return data;

            // Если guItems пустой, возвращаем все данные без фильтра по GU (все для АБП)
            // if (this.guItems.length === 0) return data;

            // Иначе применяем фильтрацию
            const guSet = new Set(this.guItems);

            if ([124].includes(this.currAbp.abp)) {
                return data.filter(item => guSet.has(item.gu) && this.currRegion?.code?.includes(item?.region));
            } else {
                return data.filter(item => guSet.has(item.gu));
            }
        },
        getData(data) {
            try {
                this.loading = true;
                const availableGuCodes = new Set(this.guFullBase.map(row => row.code));

                this.requestsData = data
                    .filter(item => !item.gu || availableGuCodes.has(item.gu))
                    .sort((a, b) => b.create_date - a.create_date);

                this.requestsData.forEach((item, index) => {
                    this.guFullBase.forEach((row, ind) => {
                        if (row.code === item.gu) {
                            this.$set(item, 'localText', row.localText);
                            this.$set(item, 'check', false);
                        }
                    });
                    if (item.parent === null && item.level === 'gu' && [35].includes(item.status.status)) {
                        this.$set(item, 'checking', true);
                        this.checkCount += 1;
                    } else {
                        this.$set(item, 'checking', false);
                    }
                });
                // Применяем базовую фильтрацию
                this.requestsBase = this.baseFilter(this.requestsData);
                if (this.selectedAlteration !== null && this.selectedAlteration.code !== 'all') {
                    this.requestsBase = this.requestsBase.filter((item) => item.requestType === this.selectedAlteration.code);
                }
                if (this.selectedStatus !== null && this.selectedStatus.code !== 0) {
                    this.requestsBase = this.requestsBase.filter((item) => item.status.status === this.selectedStatus.code);
                }
                // Условная сортировка: только если guItems не пустой
                if (this.guItems.length > 0) {
                    this.requestsBase = this.requestsBase.sort((a, b) => b.create_date - a.create_date);
                }

                this.addUserName(this.requestsData);
                this.loading = false;
            } catch (error) {
                this.makeToast('danger', this.setText('errors'), error.toString());
            }
        },
        addUserName(data) {
            const unicUserIdList = [...new Set(
                data
                    .map(item => item?.user_id)
                    .filter(id => id != null && id !== '')
            )];
            this.loadUsers(unicUserIdList);
        },
        async filterChanged() {
            await this.loadData(this.year, this.currRegion, this.currAbp, this.currGu);
        },
        async loadUsers(arr) {
            try {
                // Создаем Map для быстрого поиска пользователей
                const existingUsersMap = new Map(
                    this.userList.map(user => [user.id, user])
                );
                // Фильтруем только тех пользователей, которых еще нет в кеше
                const newUserIds = arr.filter(id => !existingUsersMap.has(id));
                // Загружаем только новых пользователей
                for (const item of newUserIds) {
                    const response = await fetch('/api-py/get-realm-user/' + item);
                    const currUser = await response.json();
                    if (currUser !== undefined) {
                        this.userList.push(currUser);
                    }
                }
                this.getUsers();
            } catch (error) {
                this.makeToast('danger', this.setText('errors.users'), error.toString());
            }
        },
        getUsers() {
            if (!this.requestsBase) return;

            // Создаем Map для быстрого поиска пользователей по ID
            const userMap = new Map(
                this.userList
                    .filter(user => user !== null)
                    .map(user => [user.id, `${user.firstName} ${user.lastName}`])
            );

            // Проходим по заявкам и устанавливаем userName
            this.requestsBase.forEach((item) => {
                const userName = userMap.get(item.user_id);
                if (userName) {
                    this.$set(item, "userName", userName);
                }
            });
        },
        clearParam() {
            this.currRegion = null;
            this.currAbp = null;
            this.currGu = null;
            this.year = `${new Date().getFullYear()}`;

        },
        openFilterByRef(refName) {
            const drop = this.$refs.drop;
            drop.show(true);
            this.$emit('openFilterByRef', refName);
            let refItem;
            switch (refName) {
                case 'filterYear':
                    refItem = this.$refs.filterYear;
                    break;
                case 'filterAbp':
                    refItem = this.$refs.filterAbp;
                    break;
                case 'filterGu':
                    refItem = this.$refs.filterGu;
                    break;
                case 'filterReg':
                    refItem = this.$refs.filterReg;
                    break;
                case 'refAlteration':
                    refItem = this.$refs.refAlteration;
                    break;
                case 'refStatus':
                    refItem = this.$refs.refStatus;
                    break;
                default: break;
            }
            setTimeout(() => refItem.$el.focus(), 100);
        },
        reset: function() {
            this.deletedAlterationFiles = [];
            this.loadData(this.year, this.currRegion, this.currAbp, this.currGu);
        },
        async saveRequest() {
            this.saveTrue = false;
            this.cDis = true;
            if (this.alterationType.description !== null && this.alterationType.requestType !== null && this.currentAlteration.number !== '') {
                this.loading = true;
                await this.svRequest();
            } else {
                this.saveTrue = true;
            }
        },
        syncFile: function (e) {
            e.preventDefault();
            if (this.editRequest) {
                this.editedAlterationFiles.push(e.target.files[0]);
            } else  {
                this.createdAlterationFiles.push(e.target.files[0]);
            }
        },
        async svRequest() {
            if (this.alterationType.requestType === 'budget_adjustment' || this.alterationType.requestType === 'budget_clarification') {
                this.currentVariant = null;
                if (this.newRequest) {
                    const res = await fetch(
                        `/api/budget-execution-alteration-request/variant-list?year=${this.year}&region=${this.currRegion.code}&requestType=${this.alterationType.requestType}&gu=${this.currGu.code}`
                    );
                    const variants = await res.json();
                    // this.variantBase = variants.current.sort((a, b) => (a.dateUeb - b.dateUeb > 0 ? 1 : -1));
                    this.variantBase = variants.current;
                    if (this.variantBase !== null && this.variantBase.length !== 0) {
                        this.currentVariant = this.variantBase.variantUuid;
                    }
                    else {
                        this.errorVariant = true;
                    }
                    this.alterationType.budgetVersion = this.currentVariant;
                }
            }
            this.saveFalse = false;
            this.alterationType.date = this.alterationType.date.getTime();
            this.alterationType.region = this.currRegion.code;

            if (!this.currAltStatusEdit && this.currGu) { this.alterationType.gu = this.currGu?.code; }
            let prm = ""
            if (!this.newRequest && !this.editRequest) {
                prm = "/api/budget-execution-alteration-abp-request";
                this.alterationType.gu = null;
            }
            if (this.newRequest || this.editRequest) {
                prm = "/api/budget-execution-alteration-request";
            }
            await fetch(prm,
                {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: this.alterationType.id ? "PUT" : "POST",
                    body: JSON.stringify(this.alterationType)
                })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(async json => {
                            this.currentAlteration = json;
                            this.currentAlteration.new = !this.currAltStatusEdit;
                            if (!this.currentAlteration.status) {
                                this.$set(this.currentAlteration, "status", []);
                                if (!this.currentAlteration.status.status) {
                                    this.$set(this.currentAlteration.status, "status", 1);
                                }
                            }
                            this.alterationType = {};
                            if (this.requestStatus) {
                                this.createdAlterationFiles = this.editedAlterationFiles;
                            }
                            for (let i = 0; i < this.createdAlterationFiles.length; i++) {
                                if (!this.createdAlterationFiles[i].old) {
                                    await this.saveFile(json.id, this.createdAlterationFiles[i])
                                }
                            }
                            // Добавить заявку Гу в заявку Абп
                            if (this.currentAlteration.level === 'abp') {
                                for (let i = 0; i < this.requestsBase.length; i++) {
                                    if (this.requestsBase[i].check) {
                                        await this.saveGuRequest(json.id, this.requestsBase[i].id);
                                        this.requestsBase[i].check = false;
                                    }
                                }
                            }
                            for (let i = 0; i < this.deletedAlterationFiles.length; i++) {
                                await this.deleteFile(this.deletedAlterationFiles[i].id, this.deletedAlterationFiles[i])
                            }
                            this.reset();
                            this.loading = false;
                            this.newForm = this.newRequest;
                            setTimeout(() => {
                                if (!this.newRequest && !this.editRequest) {
                                    this.$emit('referencesABPActive', this.currentAlteration);
                                }
                            }, 500)
                        });
                        this.modalForm = false;
                    } else {
                        this.loading = false;
                    }
                    if (response.status === 500) {
                        response.json().then(async json => {
                            switch (json.key) {
                                case 'modules.budgetExecutionAlteration.error.requestNumberAlreadyExists':
                                    this.saveFalse = true;
                                    this.loading = false;
                                    break;
                                case 'modules.budgetExecutionAlteration.error.savingIsBlocked':
                                    this.makeToast('danger', this.setText('errors.err'),  this.setText('messages.save_error_title'))
                                    break;
                                default:
                                    break;
                            }
                            this.alterationType.date = new Date(this.alterationType.date);
                        })
                    }
                })
        },
        deleteRequest(item) {
            this.$bvModal.msgBoxConfirm(
                this.setText('delete_confirm'),
                {
                    title: this.setText('confirmation'),
                    size: 'lg',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: this.setText('yes'),
                    cancelTitle: this.setText('canc'),
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(value => {
                    if (value) {
                        fetch("/api/budget-execution-alteration-request?requestId=" + item.id, {
                            method: "DELETE",
                        });
                        const ind1 = this.requestsData.indexOf(item);
                        this.requestsData.splice(ind1, 1);

                        const ind2 = this.requestsBase.indexOf(item);
                        this.requestsBase.splice(ind2, 1);
                    }
                })
                .catch(error => {
                    this.makeToast('danger', this.setText('errors.delete'), error.toString());
                });
        },
        saveFile: async function (id, file) {
            const data = new FormData();
            data.append("file", file);
            return await fetch("/api/budget-execution-alteration-request/file?requestId=" + id,
                {
                    method: "POST",
                    body: data
                })
                .then(response => {
                })
                .catch(error => {
                    alert("Error!");
                    console.log(error);
                });
        },
        saveGuRequest: async function (requestId, guRequestId) {
            return await fetch(`/api/budget-execution-alteration-abp-request/add-gu-request?guRequestId=${guRequestId}&requestId=${requestId}`,
                {
                    method: "POST"
                })
                .then(response => {
                })
                .catch(error => {
                    alert("Error!");
                    console.log(error);
                });
        },
        deleteFile: async function (id) {
            return await fetch("/api/budget-execution-alteration-request/file?fileId=" + id,
                {
                    method: "DELETE",
                })
        },
        typeListLoad() {
            this.requestTypeList.splice(0);
            if (this.accessLevels.position !== 'uf') {
                if (this.requestTypeOptions && this.requestTypeOptions.length > 0) {
                    this.requestTypeOptions.forEach((item) => {
                        if (!['budget_income', 'budget_income_clarification', 'budget_income_movement'].includes(item.code)) {
                            this.requestTypeList.push(item);
                            this.listAlteration.push(item);
                        }
                    });
                }
            }
            this.nameLocale(this.requestTypeList);
            this.nameLocale(this.listAlteration);
        },
        checkGU() {
            if (this.guEdit) {
                this.disButton = !this.checkedGU;
            }
            // Проверяем, пустые ли списки ГУ или подведомственных ГУ (для 261 АБП)
            const isAbp261 = this.currAbp && [261, 124].includes(this.currAbp.abp);
            const isDepartGuEmpty = isAbp261 && (!this.departGU || this.departGU.length === 0);
            const isGuBaseEmpty = !this.guBase || this.guBase.length === 0;
            // Вызываем загрузку только если нужные списки не были загружены ранее
            if (isDepartGuEmpty || isGuBaseEmpty) {
                this.loadFilters();
            }
            if (this.guBase.length !== 0 && this.currGu === null) {
                this.currGu = this.guBase[0];
            }
        },
        keyPress: function (event, pattern) {
            // const regex = new RegExp('^[0-9]+$');
            // const regex = new RegExp('^-?\\d*\\d{0,9}$');
            // const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
            this.saveFalse = false
        }, // ввод по заданному паттерну
        typeChange(){

        },
        dateChange(){
            if (this.currAltStatusEdit){
                if (this.curDate >= this.dateFrom && this.curDate <= this.dateTo) {
                    this.$set(this.alterationType, 'oldDate', this.alterationType.date);
                    this.alterationType.date = this.curDate;
                } else {
                    this.curDate = this.alterationType.date;
                }
            } else { this.alterationType.date = this.curDate; }
        },
        // при «Создать»/«Сконсолидировать» можно выбрать только дату в пределах периода из фильтра
        createDateDisabled(date) {
            return !this.currAltStatusEdit && isOutOfPeriod(date, this.dateFromForInput, this.dateToForInput);
        },
        filterApply(){
            if (this.requestsData !== null) {
                // Применяем базовую фильтрацию
                this.requestsBase = this.baseFilter(this.requestsData);

                if (this.selectedAlteration !== null && this.selectedAlteration.length !== 0 && this.selectedAlteration.code !== 'all') {
                    this.requestsBase = this.requestsBase.filter((item) => item.requestType === this.selectedAlteration.code);
                }
                if (this.selectedStatus !== null && this.selectedStatus.code !== 0) {
                    this.requestsBase = this.requestsBase.filter((item) => item.status.status === this.selectedStatus.code);
                }
                // Условная сортировка: только если guItems не пустой
                if (this.guItems.length > 0) {
                    this.requestsBase = this.requestsBase.sort((a, b) => b.create_date - a.create_date);
                }
            }
        },
        clearFilter(){
            this.selectedAlteration = this.listAlteration[0];
            this.selectedStatus = this.listStatus[0];
            if (this.requestsData !== null) {
                // Применяем базовую фильтрацию
                this.requestsBase = this.baseFilter(this.requestsData);

                // Условная сортировка: только если guItems не пустой
                if (this.guItems.length > 0) {
                    this.requestsBase = this.requestsBase.sort((a, b) => b.create_date - a.create_date);
                }
            }
        },
        async loadFilters(){
            this.isUpdatingFilters = true;
            await this.loadRegions();
            await this.loadCompany();
            this.isUpdatingFilters = false;
            this.debouncedLoadData();
        }
    },
    filters: {
        formatDate: function (value) {
            if (value) {
                const date = new Date(value);
                return date.toLocaleDateString();
            }
            return null;
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    display: flex;
    gap: 20px;
    background-color: #eef1f8;
    justify-content: space-between;
}

.content {
    height: 100%;
    .title {
        font-weight: 700;
        font-size: 14px;
        text-transform: uppercase;
        padding-left: 20px;
        margin-bottom: 26px;
    }
    .constructor,
    .forms {
        flex: 1;
    }

    .body {
        background-color: #f7f9fc;
    }

    .item {
        display: flex;
        align-items: center;
        height: 48px;
        border: 1px solid #d3dbe3;
        justify-content: space-between;
        padding: 0 10px 0 16px;

        &__title {
            font-weight: 500;
            font-size: 14px;
            color: #6087a0;
        }
    }

    .multiselect {
        max-width: 400px;
    }

    .footer {
        display: flex;
        height: 48px;
        align-items: center;
        justify-content: end;
        border: 1px solid #d3dbe3;
        border-top: 0;
        padding-right: 40.5%;
    }

    .vertical-line {
        width: 1px;
        background-color: #d3dbe3;
        margin-top: 40px;
    }
}
.add_modal {
    width:100%;
    height:100%;
    &__body {
        background-color: #f7f9fc;
        border: 1px solid #d3dbe3;
        border-radius: 5px;
        margin-bottom: 23px;
    }

    &__title {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 26px;
    }

    &__item {
        display: flex;
        align-items: center;
        height: 50px;
        border: 1px solid #d3dbe3;
        justify-content: space-between;
        padding: 0 10px 0 16px;

        &__title {
            font-weight: 500;
            font-size: 14px;
            color: #6087a0;
        }
    }

    .input-file {
        font-weight: 600;
        font-size: 14px;
        color: #6087a0;
        &-label {
            width: 400px;
            font-weight: 600;
            font-size: 14px;
            color: #6087a0;
            cursor: pointer;
            display: flex;
            justify-self: flex-start;
        }
    }
    .form-file {
        font-weight: 600;
        font-size: 14px;
        color: #6087a0;
    }
}
.button {
    border: none;
    border-radius: 10px;
}

.button-close {
    color: red;
}
.second-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 26px;
    &__title {
        font-weight: 500;
        font-size: 14px;
    }
}

.date-picker-container {
    display: flex;
    gap: 79px;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    line-height: 19px;
    color: #6087a0;

    input[type="number"] {
        border: 1px solid #bcd2e0;
        border-radius: 5px;
        padding-right: 5px;
        max-width: 80px;
        height: 28px;
        text-indent: 7px;
        text-align: left;
    }
}
::v-deep .multiselect__spinner:before,
::v-deep .multiselect__spinner:after {
    border-color: #007bff transparent transparent !important;
    border-width: 3px !important;
}

.requests-count {
    margin-top: 10px;
    font-weight: bold;
    color: #6087a0;
    font-size: 12px;
}
</style>